import { service } from '@ember/service';
import Controller from '@ember/controller';

export default class WidgetController extends Controller {
  @service currentPractice;
  @service session;
  @service prescreener;

  get useBookAppointmentLanguage() {
    return Boolean(
      this.session.isProfessionalWebsite && this.currentPractice.get('useBookAppointmentLanguage')
    );
  }

  get widgetTitleKey() {
    return this.useBookAppointmentLanguage ? 'booking.bookAnAppointment' : 'booking.widget.title';
  }

  get signInLeadKey() {
    return this.useBookAppointmentLanguage
      ? 'signIn.toBookAnAppointment'
      : 'booking.widget.signIn.toRequest';
  }
}
